/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicEmojisQueryResponse, GetApiPublicEmojisQueryParams } from "../entities/GetApiPublicEmojis";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicEmojis } from "../api/getApiPublicEmojis";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicEmojisQueryKey = (params?: GetApiPublicEmojisQueryParams) => [{ url: '/api/public/emojis' }, ...(params ? [params] : [])] as const

export type GetApiPublicEmojisQueryKey = ReturnType<typeof getApiPublicEmojisQueryKey>

export function getApiPublicEmojisQueryOptions(params?: GetApiPublicEmojisQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicEmojisQueryKey(params)
        return queryOptions<GetApiPublicEmojisQueryResponse, ResponseErrorConfig<Error>, GetApiPublicEmojisQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicEmojis(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить список эмодзи для выбора имени клиента
 * @summary Получить доступные эмодзи
 * {@link /api/public/emojis}
 */
export function useGetApiPublicEmojis<TData = GetApiPublicEmojisQueryResponse, TQueryData = GetApiPublicEmojisQueryResponse, TQueryKey extends QueryKey = GetApiPublicEmojisQueryKey>(params?: GetApiPublicEmojisQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicEmojisQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicEmojisQueryKey(params)
         

         const query = useQuery({
          ...getApiPublicEmojisQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}